import { render, staticRenderFns } from "./ViewCoachUpPrint.vue?vue&type=template&id=64015c26&"
import script from "./ViewCoachUpPrint.vue?vue&type=script&lang=js&"
export * from "./ViewCoachUpPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports